import type { TiptapDirection } from '@/lib/tiptap/types'

export const normalizeTiptapValue = (value?: null | string): string =>
  value ?? ''

export const resolveTiptapDirection = (
  direction?: TiptapDirection
): TiptapDirection => direction ?? 'ltr'

export const getDefaultTextAlignment = (
  direction: TiptapDirection
): 'left' | 'right' => (direction === 'rtl' ? 'right' : 'left')

import { type Editor } from '@tiptap/core'

export const NODE_HANDLES_SELECTED_STYLE_CLASSNAME =
  'node-handles-selected-style'

export function isValidUrl(url: string) {
  return /^https?:\/\/\S+$/.test(url)
}

export const duplicateContent = (editor: Editor) => {
  const { view } = editor
  const { state } = view
  const { selection } = state

  editor
    .chain()
    .insertContentAt(
      selection.to,
      /* eslint-disable */
      // @ts-nocheck
      selection.content().content.firstChild?.toJSON(),
      {
        updateSelection: true
      }
    )
    .focus(selection.to)
    .run()
}

export function getUrlFromString(str: string) {
  if (isValidUrl(str)) {
    return str
  }
  try {
    if (str.includes('.') && !str.includes(' ')) {
      return new URL(`https://${str}`).toString()
    }
  } catch {
    return null
  }
}

export function absoluteUrl(path: string) {
  return `${process.env.NEXT_PUBLIC_APP_URL}${path}`
}
